export default __webpack_public_path__ + "static/Dumpster-Bags-c5e992c77dc82258ed9c7d43641bf5b8.jpg";